export default {
  imageSetting: {
    title: '滤镜',
  },
  imageEditor: {
    argumentsAreEmpty: 'url, onCrop 是必传参数',
  },
}
